<script setup>
import {ref, computed, onBeforeMount} from "vue";
import YTCard from "@/components/YTCard/newIndex.vue";
import YTAvatarUpload from "@/components/YTAvatarUpload/index.vue";

const props = defineProps({
  // 是否编辑模式
  isEdit: {
    type: Boolean,
    default: false
  },
  // 双向绑定值
  modelValue: {
    required: true,
    type: Object,
  },
})
const emit = defineEmits(['success'])
onBeforeMount(async () => {

})
// 加载状态
const loading = ref(false)

/*表单相关*/
// 表单锚点
const ruleFormRef = ref()
// 表单信息，实现「双向绑定」
const ruleForm = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val)
})
// 员工头像校验规则
const checkImagesList = (rule, value, callback) => {
  const listLength = avatarUploadRef.value.fileList.length
  if (listLength < 1) {
    return callback(new Error('请上传一张员工头像'))
  }
  callback()
}
// 员工姓名校验规则
const checkName = (rule, value, callback) => {
  if (!ruleForm.value.name) {
    return callback(new Error('请填写姓名（中文）'))
  }
  if (!ruleForm.value.nameEn) {
    return callback(new Error('请填写姓名（English）'))
  }
  callback()
}
// 默认校验规则
const rulesOne = {
  avatar: [
    {required: true, validator: checkImagesList, trigger: "blur"},
  ],
  name: [
    {required: true, validator: checkName, trigger: 'blur'},
  ],
  phone: [
    {required: true, message: '请填写手机号', trigger: 'blur'},
  ],
}
// 表单校验规则
const rules = ref(rulesOne)
// 表单校验
const submit = () => {
  loading.value = true
  ruleFormRef.value.validate((valid, fields) => {
    if (valid) {
      createTherapist()
    } else {
      ElMessage.error("请根据提示修改表单信息")
      loading.value = false
    }
  })
}
// 创建员工
const createTherapist = () => {
  console.log("ruleForm", ruleForm.value)
  emit("success")
}

/*上传图片组件相关*/
// Logo图片上传组件锚点
const avatarUploadRef = ref();
// 处理logo上传成功
const handlePicSuccess = (url) => {
  ruleForm.value.avatar = null;
  ruleForm.value.avatar = url[0];
  console.log("url",url)
  console.log("url[0]",url[0])
  ruleFormRef.value.validateField("avatar");
  loading.value = false;
};
// 处理Logo图片反显
const handleReviewPic = (reviewList) => {
  avatarUploadRef.value.handleReview(reviewList);
};

/*中英文切换输入框相关Tab*/
// 理疗师名称tab
const nameTab = ref("zh")
// 介绍tab
const providerJobTitleTab = ref("zh")

defineExpose({
  handleReviewPic
})
</script>

<template>
  <div class="create_wrapper">
    <el-form
        ref="ruleFormRef"
        :model="ruleForm"
        :rules="rules"
        style="height: 100%;width: 100%;"
        class="flex"
        size="large"
    >
      <div class="create_wrapper flex_1">
        <YTCard :title="`员工信息`">
          <template #container>
            <el-form-item prop="avatar">
              <YTAvatarUpload :ali-oss-path="'SERVICE_PROVIDER_AVATAR_IMG_PATH'"
                              ref="avatarUploadRef"
                              :title="'头像'"
                              :isReplaceMode="true"
                              :isLogoMode="true"
                              :limit="1"
                              :width="80"
                              :height="80"
                              :file-size="1"
                              :isRequired="true"
                              :tips="``"
                              @progress="loading = true"
                              @success="handlePicSuccess"
              ></YTAvatarUpload>
            </el-form-item>
            <el-form-item label="姓名：" prop="name">
              <el-tabs
                  v-model="nameTab"
                  type="card"
                  class="demo-tabs"
              >
                <el-tab-pane label="中文" name="zh">
                  <el-input v-model="ruleForm.name" style="width: 318px;" placeholder="姓名"/>
                </el-tab-pane>
                <el-tab-pane label="English" name="en">
                  <el-input v-model="ruleForm.nameEn" style="width: 318px;" placeholder="name"/>
                </el-tab-pane>
              </el-tabs>
            </el-form-item>
            <el-form-item label="手机号：" prop="phone">
              <el-input maxlength="11" v-model="ruleForm.phone" style="width: 318px;" placeholder="手机号"/>
            </el-form-item>
            <el-form-item label="职务：" prop="providerJobTitle">
              <el-tabs
                  v-model="providerJobTitleTab"
                  type="card"
                  class="demo-tabs"
              >
                <el-tab-pane label="中文" name="zh">
                  <el-input v-model="ruleForm.providerJobTitle" style="width: 318px;" maxlength="12" show-word-limit placeholder="请输入职务"/>
                </el-tab-pane>
                <el-tab-pane label="English" name="en">
                  <el-input v-model="ruleForm.providerJobTitleEn" style="width: 318px;" maxlength="30" show-word-limit placeholder="Position"/>
                </el-tab-pane>
              </el-tabs>
            </el-form-item>
          </template>
        </YTCard>
        <div class="flex_left mg_b_2 mg_l_2">
          <v-btn color="primary" @click="submit">保存</v-btn>
        </div>
      </div>
    </el-form>
  </div>
</template>

<style lang="scss" scoped>
.create_wrapper {
  width: 100%;
  height: 100%;
  background-color: #fff;
  overflow: auto;
}
</style>
